import React from 'react';
import { ArServiceContextProvider } from './AccountsReceivableServiceContext';
import ArHistoryPage from './ArHistoryPage';
const ArHistoryComponent = () => {
  return (
    <ArServiceContextProvider>
      <ArHistoryPage />
    </ArServiceContextProvider>
  );
};
export default ArHistoryComponent;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/ArHistoryComponent.tsx